import React from "react";
import { Helmet } from "react-helmet";

export default function Root({ children, options }) {
	const version = options.version || "0.0.0";
	return (
		<React.Fragment>
			<Helmet>
				<meta
					name="viewport"
					content="minimum-scale=1, initial-scale=1, width=device-width"
				/>
				{options.style && (
					<link rel="stylesheet" href={`${options.style}?v=${version}`} />
				)}
			</Helmet>
			{children}
		</React.Fragment>
	);
}
